import { Resources } from "@tsTypes/subject-schema";
import CommandTermsIcon from "../../../../public/static/icons/resources/commandtermicon.svg";
import CramsheetIcon from "../../../../public/static/icons/resources/cramsheeticon.svg";
import DefinitionIcon from "../../../../public/static/icons/resources/definitionicon.svg";
import ExamBeakdownIcon from "../../../../public/static/icons/resources/exambreakdownicon.svg";
import FlashcardIcon from "../../../../public/static/icons/resources/flashcardicon.svg";
import IaCriteriaIcon from "../../../../public/static/icons/resources/iacriteriaicon.svg";
import IaExamplesIcon from "../../../../public/static/icons/resources/iaexampleicon.svg";
import MockExamIcon from "../../../../public/static/icons/resources/mockexamicon.svg";
import NoteIcon from "../../../../public/static/icons/resources/noteicon.svg";
import QuestionIcon from "../../../../public/static/icons/resources/questionicon.svg";
import SyllabusIcon from "../../../../public/static/icons/resources/syllabusicon.svg";
import TestBuilderIcon from "../../../../public/static/icons/resources/testbuildericon.svg";
import TestIcon from "../../../../public/static/icons/resources/topictesticon.svg";
import VideoIcon from "../../../../public/static/icons/resources/videoicon.svg";
import ExamTestIcon from "../../../../public/static/icons/resources/examtesticon.svg";

const resources: { [name in Resources]: any } = {
  "command terms": CommandTermsIcon,
  "exam breakdown": ExamBeakdownIcon,
  "ia criteria": IaCriteriaIcon,
  "ia examples": IaExamplesIcon,
  syllabus: SyllabusIcon,
  "test taker": TestBuilderIcon,
  "test builder": TestBuilderIcon,
  videos: VideoIcon,
  notes: NoteIcon,
  flashcards: FlashcardIcon,
  questions: QuestionIcon,
  definitions: DefinitionIcon,
  "cram sheets": CramsheetIcon,
  "topic tests": TestIcon,
  "mock exams": MockExamIcon,
  "exam tests": ExamTestIcon,
  "individual topic test": TestIcon,
};

export default function RawResourceIcon({
  className,
  subjectNameLower,
  resource,
  size = 20,
}: {
  className?: string;
  subjectNameLower: string;
  resource: Resources;
  size?: string | number;
}) {
  const Icon = resources[resource];
  return (
    <Icon
      className={className}
      width={size}
      height={size}
      alt={`IB ${subjectNameLower} ${resource}`}
    />
  );
}
